export default "__VITE_ASSET__6d7ab1cc__"